module.exports = "https://files.cnvos.lb.djnd.si/static/images/kultura.png?4d84eebec21faa3167a41f381e592919";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section-news-categories/kultura.png
// module id = 122
// module chunks = 1 2